import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { Store } from '../../store';

const More = ({ id, content }) => {
    const { commentCount } = content;

    const store = Store.useContainer();
    const { changeStates } = store;

    const handleClick = () => {
        changeStates({ showReplyModal: true, replyLisRootId: id, replyList: [], replyPage: 1 });
    };

    return (
        <div className={styles.wrap} onClick={handleClick}>
            查看全部{commentCount}条回复
        </div>
    );
};

More.propTypes = {
    id: PropTypes.string,
    content: PropTypes.object,
};

export default errorBoundary(More);
